import React from 'react'
import AdminAffiliationChangeForm from './AdminAffiliationChangeForm'

const translateUserToAdminAffiliationChangeFormValues = (user) => ({
  id: user.id,
  appraiserId: user.affiliations && user.affiliations.some(a => a.name === 'APPRAISER') ? user.affiliations.find(a => a.name === 'APPRAISER').id : null,
  inspectorId: user.affiliations && user.affiliations.some(a => a.name === 'INSPECTOR') ? user.affiliations.find(a => a.name === 'INSPECTOR').id : null,
  lenderId: user.affiliations && user.affiliations.some(a => a.name === 'LENDER') ? user.affiliations.find(a => a.name === 'LENDER').id : null,
  servicerId: user.affiliations && user.affiliations.some(a => a.name === 'SERVICER') ? user.affiliations.find(a => a.name === 'SERVICER').id : null,
  sarId: user.affiliations && user.affiliations.some(a => a.name === 'SAR') ? user.affiliations.find(a => a.name === 'SAR').id : null,
  ffpsUserName: user.affiliations && user.affiliations.some(a => a.name === 'FFPS') ? user.affiliations.find(a => a.name === 'FFPS').id : null,
  otherRequesterId: user.affiliations && user.affiliations.some(a => a.name === 'OTHER') ? user.affiliations.find(a => a.name === 'OTHER').id : null,
})

/**
 * The page within the user admin section of the admin gear for changing the affiliations of other users
 * 
 * @author Alex Clary
 * 
 */
const AdminAffiliationChangePage = ({ user, updateUserAffiliations }) =>
  <div>
    <AdminAffiliationChangeForm
      form={`userAdminAffiliationForm${user.id}`}
      onSubmit={updateUserAffiliations}
      user={user}
      initialValues={translateUserToAdminAffiliationChangeFormValues(user)} />
  </div>

export default AdminAffiliationChangePage